import React from "react";
import "./LibraryStyles.css";
import { Link } from "react-router-dom";
const EMagazines = () => {
  return (
    <div className="library-page">
      <h1 className="library-title">E-Magazines</h1>
      <p className="library-description">
        Browse through our inspirational digital magazines featuring cultural insights, spiritual guidance, and community stories.
      </p>

      <div className="library-grid">
        <div className="library-item">
          <h3>Navveer Monthly</h3>
          <p>Covering monthly updates, activities, and reflections from our foundation.</p>
          <Link to="#" className="library-link">View Issue</Link>
        </div>

        <div className="library-item">
          <h3>Inner Light Digest</h3>
          <p>Spiritual wisdom and practices compiled by our editorial team.</p>
          <Link to="#" className="library-link">View Issue</Link>
        </div>
      </div>
    </div>
  );
};

export default EMagazines;
